import type { FieldRenderProps } from 'react-final-form';

import { datadogLogs } from '@datadog/browser-logs';

import { PLACEHOLDER_TEXT } from '../../pages/Adjustment/Adjustment.helpers';

export const required = (value?: string | number) => (value ? undefined : 'Required');

export const maxRequired = (value: string | number, max?: number) => {
  const isRequired = required(value);

  if (isRequired || !max) {
    return isRequired;
  }

  const numericValue = Number(
    Number.isInteger(value)
      ? value
      : value.toString().replaceAll(',', ''),
  );

  if (numericValue > max) {
    return 'Price adjustment must be less than 75% of the closing bid';
  }

  return undefined;
};

export const FETCH_ERROR_MESSAGE = 'An error occurred while submitting your price adjustment. Please try again.';

export function logOnFieldComplete(meta: FieldRenderProps<string | number>['meta'], originalOnBlur: (e: React.FocusEvent<HTMLElement>) => void) {
  return (e?: React.FocusEvent<HTMLElement>) => {
    if (!e) {
      return;
    }

    if (meta.dirty) {
      const target = e.target as HTMLInputElement;
      datadogLogs.logger.info('Field completed', { fieldName: target.name, fieldValue: target.value });
    }

    originalOnBlur(e);
  };
};

export const getIntent = (meta: FieldRenderProps<string | number>['meta']) => {
  // If field hasn't been touched AND is pristine (no user interaction)
  if (!meta.touched && meta.pristine) {
    if (meta.valid && meta.initial === PLACEHOLDER_TEXT) {
      return undefined;
    }
    // Check if there's a valid initial value
    return meta.error || !meta.initial ? undefined : 'success';
  }

  // User has interacted - show validation state
  return meta.error ? 'error' : 'success';
};
